import Navbar from "../../components/navbar/Navbar";
import GamesVideo from "../../components/games_video/Games_Video";
import "./Games_Video.css";

function GamesVideoPage() {
  return (
    <div className="games-video-page">
      <Navbar />
      <GamesVideo />
    </div>
  );
}

export default GamesVideoPage;
